import headerImg from '../../../assets/services/MobApp/headerImg.svg'

import img1 from '../../../assets/dummy1.avif'
import img2 from '../../../assets/dummy2.avif'
import img3 from '../../../assets/dummy3.avif'

import backend from '../../../assets/services-web-App/backend.svg'
import frontend from '../../../assets/services-web-App/frontend.svg'
import product from '../../../assets/services-web-App/product.svg'
import quality from '../../../assets/services-web-App/quality.svg'

import support from '../../../assets/services-web-App/support.svg'
import prototype from '../../../assets/services-web-App/prototype.svg'
import planning from '../../../assets/services-web-App/planning.svg'
import devops from '../../../assets/services-web-App/devops.svg'
import deployment from '../../../assets/services-web-App/deployment.svg'

import enterprise from '../../../assets/services-web-App/enterprise.svg'
import webConsulting from '../../../assets/services-web-App/web-consulting.svg'
import cloudBased from '../../../assets/services-web-App/cloud-based.svg'
import progressive from '../../../assets/services-web-App/progressive.svg'
import supplyChain from '../../../assets/services-web-App/supply-chain.svg'

import andriod from '../../../assets/services/MobApp/andriod.svg'
import ios from '../../../assets/services/MobApp/ios.svg'
import qaTest from '../../../assets/services/MobApp/qaTest.svg'

import img from '../../../assets/services/img.svg'


import flutter from '../../../assets/services/MobApp/img7.svg'
import myimg1 from '../../../assets/services-web-App/tech/img1.svg'
import myimg2 from '../../../assets/services-web-App/tech/img2.svg'
import myimg3 from '../../../assets/services-web-App/tech/img3.svg'
import img4 from '../../../assets/services-web-App/tech/img4.svg'
import img5 from '../../../assets/services-web-App/tech/img5.svg'
import img9 from '../../../assets/services-web-App/tech/img9.svg'
import img10 from '../../../assets/services-web-App/tech/img10.svg'
import img12 from '../../../assets/services-web-App/tech/img12.svg'
import img13 from '../../../assets/services-web-App/tech/img13.svg'
import img14 from '../../../assets/services-web-App/tech/img14.svg'
import img15 from '../../../assets/services-web-App/tech/img15.svg'
import img17 from '../../../assets/services-web-App/tech/img17.svg'
import img19 from '../../../assets/services-web-App/tech/img19.svg'
import img24 from '../../../assets/services-web-App/tech/img24.svg'


import review from '../../../assets/dummyreview.png'


export const headerData = {
    title1: 'Mobile App',
    title2: 'Development Services',
    desc: 'We are a leading mobile app development company in the USA, housing domain-savvy developers to design and develop Android, iOS and cross-platform applications customized to your business needs and identity. So, jump into the Codezone bandwagon today and benefit from our exclusive value-added services!',
    points: [
        'Advanced tech stack such as Elixir, Flutter, React Native, Swift and more.',
        'Wallet-friendly engagement models to hire remote app developers',
        'Staffing within 1-2 weeks',
        'Daily collaborative meetings with Product Managers.'
    ],
    img: headerImg
}

export const BenefitsData = {
    title1: 'Why Should You Choose CodeZone For Mobile',
    title2: 'App Development Services?',
    desc: 'As the leading and trusted web app development company in the U.S.A., the U.K., and Canada, we offer a personalized package of value-added services.',
    cards: [
        {
            title: 'Pocket-Friendly Services',
            desc: 'End up saving thousands of dollars with our exclusive and customized web application development services, which include a 7-day trial, experienced product managers, and full-cycle application testing and debugging.'
        },
        {
            title: 'Domain Specialists',
            desc: 'With hands-on experience in mobile app development services, Codezone houses a flourishing community of 500+ developers who have delivered 97% customer satisfaction across industries — Healthcare, Fintech, and more!'
        },
        {
            title: 'Community of large Tech Veterans',
            desc: 'Codezone has hands-on expertise in web application development services and a thriving community of large developers that have achieved 97% client satisfaction across sectors such as Healthcare, Fintech, and more!'
        },
        {
            title: 'Specialized in Most Advanced Tech Stack',
            desc: 'Utilize the expertise of our proficient developers who have a strong grasp on the most popular programming languages, frameworks, databases, and other toolkit suites.'
        },
        {
            title: '100% Confidentiality As Promised',
            desc: 'You may be confident in the secrecy of your project! Our web app development team prioritizes cutting-edge technology and techniques to safeguard your data and other essential information.'
        },
    ]
}

export const recentworkdata = {
    title1: 'Our Recent',
    title2: 'Work',
    sliderData: [
        {
            title: 'dummy 1',
            img: [img1],
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  '
        },
        {
            title: 'dummy 2',
            img: [img2],
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  '
        },
        {
            title: 'dummy 3',
            img: [img3],
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  '
        },
    ]
}

export const SuccessDrivenData = {
    title1: 'Build A Success-Driven Development Team To',
    title2: 'Protect Your Project Scope',
    desc: 'Prevent scope creep, frequent delays and unplanned changes by building a development team. Here’s what a success-driven development team looks like.',
    cards: [
        {
            title: 'Frontend Developers',
            desc: "The visual aspect of a web app is the face of your brand. Hire web app developers to determine how your users will view and interact. They bring the web app's layout to life by building scripts and collaborating with dynamic libraries and frameworks.",
            img: frontend
        },
        {
            title: 'Backend Developer',
            desc: "Want a clear picture of database structure, data processing, and third-party integrations? Our backend web applications developers will manage everything for you in a timely manner. They actively ensure that data is exchanged securely and efficiently.",
            img: backend
        },
        {
            title: 'Product Manager',
            desc: 'Our domain-savvy product manager keeps the team focused and protects the project scope. They are in charge of the budget, planning, and ensuring that the team is filled with the greatest minds.',
            img: product
        },
        {
            title: 'Quality Assurance Engineer',
            desc: 'Our Q/A testing does not occur at the conclusion of the development process. Instead, the process begins once the team has created a UI layout and continues till the launch stage. To guarantee that the design meets the criteria, our QA assurance engineer will use automated or manual testing methods.',
            img: quality
        },
    ]
}

export const developmentProcessData = {
    title1: 'Discover Our Fine-Tuned Mobile Application',
    title2: 'Development Process',
    desc: "Journey with us into the universal mobile app development process to paint the canvas of your next big project.",
    processNames: ['Planning', 'Design', 'Prototype', 'Development', 'Software Quality Assurance', 'DevOps Services', 'Support & Maintenance'],
   processInfo : [
    {
        title: 'Planning',
        desc: 'Outline all procedures and activities necessary to ensure project success and develop a complete set of plans to manage the project from this phase till project completion. It provides a clear structure of scope, deliverables, processes, budget, tech stack and timeline.',
        img: planning,
        link : '/contact-us'
    },
    {
        title: 'Design',
        desc: 'To create a marketable product, refine your ideas through market research validation. Save expenses and eliminate risks by working with our focused web application development team that moves smoothly through numerous iterations and launches high-functioning prototypes via a streamlined MVP development approach.',
        img: prototype,
        link : '/ui-ux-design'
    },
    {
        title: 'Development',
        desc: 'With our well-established bespoke web application development services, your brand will stand out from the crowd. Build safe, scalable, accessible, and custom software solutions with our specialized SCRUM team - tailored to your firm’s specifications and market expectations.',
        img: deployment,
        link : '/'

    },
    {
        title: 'Software Quality Assurance',
        desc: 'Reduce errors in your codes and interfaces with our automated software quality assurance geared toward higher ROI. To provide the greatest experience for your consumers, we use fine-tuned tools and construct sturdy walls with our penetration testing services.',
        img: quality,
        link : '/hire-sqa-engineers'

    },
    {
        title: 'DevOps Services',
        desc: 'With our well-engineered DevOps services, you can transition to continuous delivery and ensure durable data pipelines and speedier time-to-market. We integrate your existing infrastructure into a strong ecosystem using agile approaches while maintaining software quality.',
        img: devops,
        link : '/hire-sqa-engineers'

    },
    {
        title: 'Support & Maintenance',
        desc: "Deliver high-performance software to your customers by choosing our advanced web app development strategy, which includes bug-fixing, on-call production support, product improvements, user support, and training. Use Codezone's qualified personnel to optimize the functionalities of your product.",
        img: support,
        link : '/software-development'

    },
]
}

export const DevelopmentServicesData = {
    title1: 'A Sneak Peak of Our Custom Mobile App',
    title2: 'Development Services',
    desc: 'Delivering convenience-focused mobile application development services in any form is what we’re inclined towards.',
    cards: [
        {
            title: 'Android App Development',
            desc: 'Hire our remote team of android developers to create feature-rich mobile apps that complement your venture and generate revenue with each converted user.',
            img: supplyChain
        },
        {
            title: 'iOS App Development',
            desc: 'Discover a constellation of star iOS developers at Codezone, a top-notch mobile application development company that creates user-friendly iPhone & iPad Apps.',
            img: progressive
        },
        {
            title: 'Native App Development',
            desc: 'Outsource from a booming community of smartphone app developers to ensure a high degree of reliability and uncompromised performance in your native applications.',
            img: enterprise
        },
        {
            title: 'Hybrid App Development',
            desc: 'Witness your business reaching out to a broader customer base through hybrid app development services that offer faster time to market and cross-channel mobility.',
            img: webConsulting
        },
        {
            title: 'Cross-Platform App Development',
            desc: 'Avoid limitations by scheduling a 7-day trial for our cross-platform mobile app development services that offer cost-effectiveness as the code is reusable.',
            img: cloudBased
        },
    ]
}

export const hireWebData = {
    title1: 'Hire Mob Application Developers To Extend',
    title2: 'The Roots of Your Business',
    desc: 'Get ready to elevate the performance and extend the functionalities of your web applications by hiring our mob application developers today!',
    questions: [
        {
            question: 'Android Developers',
            answer: 'Create apps for Android-based smartphones today! Hire our mobile app developers who have a strong grasp of Android SDK, RESTful APIs, Android UI design concepts, offline storage, threading, performance optimization, natural interfaces, open-source expertise, continuous integration, and more.',
            img: andriod
        },
        {
            question: 'QA Tester',
            answer: 'Writing test cases, sanity/smoke testing, functional testing, black box testing, integration testing, regression testing, retesting, automated testing, Gui testing, and UAT (user acceptance testing) are key specialities of our software QA testers.',
            img: qaTest
        },
        {
            question: 'iOS Developers',
            answer: "Being fluent in programming languages such as Objective-C or Swift, our fantastic iOS developers proactively take up the responsibilities of designing and developing the underlying programme, testing the application, resolving bugs, code maintenance, and releasing new upgrades.",
            img: ios
        },
        {
            question: 'Designer',
            answer: "Mobile app designers are in charge of the whole look and feel of a mobile application, including the User Interface (UI) and the User Experience (UX) design. They influence design-related decisions, Handling the end-to-end product design that comprises color, font, navigation, and other factors.",
            img: andriod
        },
    ]
}

export const ModelData = {
    title1: 'A Glance At Our Customer-Centric',
    title2: 'Engagement Models',
    desc: 'Choose a business engagement model that best fits your preferences.',
    img,
    tags: ['Resource Augmentation', 'Dedicated Team', 'Fixed Gig']
}


export const techData = {
    title1: 'Our Favorite Folder Of The',
    title2: 'Technologies We Use',
    images: [
        {
            title : 'Java',
            img : myimg1
        },
        {
            title : 'Javascript',
            img : myimg2
        },
        {
            title : 'Typescript',
            img : myimg3
        },
        {
            title : 'PHP',
            img : img4
        },
        {
            title : 'C#',
            img : img5
        },
        {
            title : 'Go',
            img : img9
        },
        {
            title : 'Python',
            img : img10
        },
        {
            title : 'Html',
            img : img12
        },
        {
            title : 'React js',
            img : img13
        },
    
        {
            title : 'Angular Js',
            img : img14
        },
        {
            title : 'Vue Js',
            img : img15
        },
        {
            title : 'Sass',
            img : img17
        },
        {
            title : 'Django',
            img : img19
        },
        {
            title : 'Css',
            img : img24
        },
        {
            title : 'Flutter',
            img : flutter
        }
    
        
    ]
}

export const reviewData = {
    title1: 'Cultivating Long-Term',
    title2: 'Relationships',
    sliderData: [
        {
            title: 'review 1',
            img: review,
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  ',
            rating: 2
        },
        {
            title: 'review 2',
            img: review,
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  ',
            rating: 3.5
        },
        {
            title: 'review 3',
            img: review,
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  ',
            rating: 5,
        },
    ]
}

export const FAQData = [
    {
        question: 'How much does it cost to develop a Mobile application?',
        answer: 'The cost of mobile app development depends on various factors such as objectives, number of developers, project scope, industry, budget, timeline, the complexity of the project, features & functionalities, and tech stake.'
    },
    {
        question: ' Why Outsource Dedicated Mobile App Developers from CodeZone?',
        answer: "It is always better to outsource your project to the best mobile app development company when your main objective is to increase return on investment (ROI), either in terms of customer base or operational efficiency. Most importantly, outsourcing dedicated mobile app developers from Codezone, a bespoke mobile application development agency in the USA, will reduce the development cost, provide ongoing support, ensure quality, access to the latest technologies and expertise, faster project completion and more."
    },
    {
        question: 'What is Custom Mobile App Development?',
        answer: "Custom mobile app development is the process of creating apps that are specially tailored to your company's needs. Such an app, whether fully or partially personalized, is designed to meet the demands of a specific audience rather than a large group of individuals."
    },
    {
        question: 'What is the mobile app development process?',
        answer: "At Codezone, our methodologies evolve around the project requirements because each app is different. Codezone offers a customer-centric process that involves a consultation session in which we discuss the ins and outs of your project so when we launch the projects, our team is well-prepared. Once the development stage kicks off, we design the architecture and UI/UX of the design. Our competent mobile app development team develops, tests, deploys and then releases the mobile application. If our client requests, we provide prolonged support and maintenance services, which is the final stage of our progressive mobile application development solutions process. The objective of each activity and action taken is to make our platform user-friendly and effective for your business in the long run."
    },
]